export function resolveContent(content) {
    switch (typeof content) {
        case 'string':
            return content.charAt(0).toUpperCase();
        case 'number':
            return content > 99 ? '99+' : content;
        default:
            return content;
    }
}
export function resolveNumericContentFontSize(content) {
    if (content < 10) {
        return 'inherit';
    }
    if (content > 99) {
        return '60%';
    }
    return '75%';
}
